var exports = {
  "AS": "xcc377c0b--cdfc9a--item",
  "DD": "xcc377c0b--cdfc9a--title",
  "p_": "xcc377c0b--cdfc9a--finish-date",
};

module.exports = exports;
